import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.splice.js";
import { request } from "@/js/http/http_request";
import { formRules } from "@/js/form_rules.js";
export default {
  name: "SendInvitationAsConsultantModal",
  data: function data() {
    return {
      formConsultantCode: {
        valid: false,
        sending: false,
        items: [],
        message: null
      },
      currentUser: {},
      rules: formRules,
      consulantCodeInviteModalShown: false
    };
  },
  created: function created() {},
  methods: {
    getUser: function getUser() {
      var _this = this;
      request("/v1/user", "get", null, true, "api").then(function (response) {
        _this.currentUser = _objectSpread({}, response.data);
      }).catch(function (_) {
        _this.$toasted.show("An error occured. Please contact an administrator.", {
          type: "error"
        });
      });
    },
    open: function open() {
      this.getUser();
      this.consulantCodeInviteModalShown = true;
    },
    close: function close() {
      this.consulantCodeInviteModalShown = false;
    },
    removeConsultantFormItem: function removeConsultantFormItem(item) {
      this.formConsultantCode.items.splice(this.formConsultantCode.items.indexOf(item), 1);
    },
    sendInviteConsultantCode: function sendInviteConsultantCode() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this2.formConsultantCode.sending = true;
              _this = _this2;
              _context.next = 4;
              return request("/v1/users/consultant/invite", "post", {
                idUser: _this.currentUser.id_user,
                ConsultantCode: _this.currentUser.consultant_code,
                SendTo: _this.formConsultantCode.items,
                Message: _this.formConsultantCode.message
              }, true, "api").then(function () {
                _this.$toasted.show("The invites were successfully sent.", {
                  type: "success"
                });
                _this.formConsultantCode.items = [];
                _this.formConsultantCode.message = "";
                _this.consulantCodeInviteModalShown = false;
              }).catch(function (error) {
                _this.$toasted.show("An error occured. Please contact an administrator.", {
                  type: "error"
                });
              });
            case 4:
              _this2.formConsultantCode.sending = false;
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  }
};